import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface FilterField {
  fieldName: string;
  fieldType: string;
  displayName: string;
}

export interface FilterFieldGroup {
  fields: FilterField[];
  availableOptions: Record<string, string[]>;
}

export interface FilterOptionsRes {
  relativityFields: FilterFieldGroup;
}

/**
 * Fetch filter options for a matter, including Relativity metadata fields.
 */
export const useGetFilterOptions = ({ matterId }: { matterId: string | null }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<FilterOptionsRes>(
    [QueryEntity.MetadataFilterOptions, { matterId }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matters/${matterId}/filter-options`, fetchConfigGET);
      if (!res.ok) {
        throw new Error('Failed to fetch filter options');
      }
      return res.json();
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
